import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../Libs/Api/AxiosConfig";



export const getLayout = createAsyncThunk(
    'Layout/getLayout',
    async () => {

        const res = await api.post(`/User/Layout`);
        return res.data;
    })


export const LayoutSlice = createSlice({
    name: 'Layout',
    initialState: {
        loading: false,
        error: false,
        companyCode: "",
        companyType: "",
        userType: "",
        agencyType: "",
        agency_type_code: "",
        agency_type_name: "",
        company_type_code: "",
        company_type_name: "",
        title: "",
        legalName: "",
        status: "",
        status_code: "",
        firstName: "",
        lastName: "",
        username: "",
        avatar: null,
        companyTimezone:"",
        plans: 1,
        modules: [],
        language: [],
        currency: [],
        tax: [],
        policy: [],
        commissions:[]

    },
    reducers: {
        SetLoading: (state) => {
            state.loading = true;

        },

        setCancelPolicy: (state, action) => {
            
            state.policy = action.payload
        },
        setTaxAndFee:(state,action) =>{
            state.tax = action.payload
        }


    },
    extraReducers: (builder) => {

        builder.addCase(getLayout.pending, (state, { payload }) => {
            state.loading = true;
        })

        builder.addCase(getLayout.fulfilled, (state, { payload }) => {
            state.loading = false;

            if (payload.payload.status) {

                const { data, modules, definitions } = payload.payload

                state.loading = false;
                state.error = false;
                state.companyCode = data.companyCode;
                state.companyType = data.companyType;
                state.userType = data.userType;
                state.agencyType = data.agencyType;
                state.agency_type_code = data.agency_type_code;
                state.agency_type_name = data.agency_type_name;
                state.company_type_code = data.company_type_code;
                state.company_type_name = data.company_type_name;
                state.title = data.title;
                state.legalName = data.legalName;
                state.status = data.status;
                state.status_code = data.status_code;
                state.firstName = data.firstName;
                state.lastName = data.lastName;
                state.username = data.username;
                state.avatar = data.avatar;
                state.plans = data.plans === null ? 1 : data.plans;
                state.modules = modules;
                state.language = definitions.language;
                state.currency = definitions.currency;
                state.tax = definitions.tax;
                state.policy = definitions.policy;
                state.companyTimezone = data.timezone;
                state.commissions = definitions.commissions

            } else {
                state.requestCount = 1
                state.auth = false;
                state.error = true;
                state.reason = payload.payload.reason;
            }
        })

        builder.addCase(getLayout.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = true;
            state.reason = "";
        })

    }
})

export const { SetLoading, setCancelPolicy, setTaxAndFee } = LayoutSlice.actions;



export const LayoutReducer = LayoutSlice.reducer